import { PanoramaVariantIcon } from './PanoramaVariantIcon';

/**
 * author: Google
 * id 06830F7E-C93D-445A-AED5-7832A9E885C5
 * name panorama-variant
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/panorama-variant.svg
 * tags
 * - Photography 
 */
export const Image360Icon = PanoramaVariantIcon;
export default Image360Icon